import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import { api } from "@/lib/api";
import { OrderCard } from "@/components/OrderCard";
import { Spinner } from "@/components/ProtectedRoute";

export default function MyOrders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    api.get("/orders/mine").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  }, []);
  if (!orders) return <Spinner />;
  return (
    <div className="mx-auto max-w-4xl px-4 pt-6 sm:px-6">
      <h1 className="text-3xl font-extrabold tracking-tight">I miei ordini</h1>
      {orders.length === 0 ? (
        <div data-testid="my-orders-empty" className="card-mc mt-6 px-6 py-14 text-center">
          <Package className="mx-auto h-10 w-10" />
          <div className="mt-3 font-display text-lg font-extrabold">Ancora nessun ordine</div>
          <Link to="/" className="btn-mc mt-5">Vai al catalogo</Link>
        </div>
      ) : (
        <div data-testid="my-orders-list" className="mt-5 space-y-4">
          {orders.map((o) => <OrderCard key={o.id} o={o} />)}
        </div>
      )}
    </div>
  );
}
